import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ProcessStepPage from '../ProcessStepPage'

const propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            stepType: PropTypes.string.isRequired,
            stepName: PropTypes.string.isRequired,
        }),
    ).isRequired,
    assetNumber: PropTypes.string.isRequired,
    inputCallback: PropTypes.func,
    isSummaryView: PropTypes.bool,
    className: PropTypes.string,
    changedBy: PropTypes.string,
}

const ProcessGroup = ({
    steps,
    assetNumber,
    inputCallback,
    className = '',
    isSummaryView = false,
    changedBy,
}) => {
    const mainLevelSteps = useMemo(() => {
        return steps.filter(({ isNestedStep }) => {
            return !isNestedStep
        })
    }, [steps])

    return (
        <div css={className}>
            {mainLevelSteps.map((step) => {
                return (
                    <ProcessStepPage
                        key={step.stepName}
                        step={step}
                        curentGroupSteps={steps}
                        assetNumber={assetNumber}
                        inputCallback={inputCallback}
                        isSummaryView={isSummaryView}
                        changedBy={changedBy}
                    />
                )
            })}
        </div>
    )
}

ProcessGroup.propTypes = propTypes

export default ProcessGroup
